(() => {
  const styleId = 'codebrwn-shopify-form-styles';

  const contactStyles = `
    :host {
      --app-embed-padding-x: 0px;
      --app-embed-padding-y: 0px;
      --inline-container-max-width: 100%;
      --container-max-w: 100%;
      --forms-body-font: normal 400 14px var(--font-body-family, Arial, sans-serif);
      --forms-heading-font: normal 500 22px var(--font-heading-family, Georgia, serif);
      --form-field-border: 1px solid #e7e3dc;
      --form-field-border-focused: 1px solid #151515;
      --form-field-border-radius: 0px;
      --button-border-radius: 0px;
      --form-field-padding: 18px;
      --button-padding: 18px;
    }

    [data-sizing='form-wrapper'],
    section[role='dialog'],
    #form-container-ref {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: none !important;
      overflow: visible !important;
    }

    #form-container-ref section {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      overflow: visible !important;
    }

    div:has(> #form-container-ref) {
      justify-content: stretch !important;
      grid-template-columns: minmax(0, 1fr) !important;
    }

    #form-container-ref {
      width: 100% !important;
      max-width: none !important;
    }

    form[data-testid='form'] {
      box-sizing: border-box !important;
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 24px !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 1px !important;
      overflow: visible !important;
    }

    form[data-testid='form'] > div {
      min-width: 0;
    }

    form[data-testid='form'] > div:first-child {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }

    form[data-testid='form'] > div:has([data-testid='field-custom#your_message']),
    form[data-testid='form'] > div:has(textarea),
    form[data-testid='form'] > button[data-testid='btn-form-submit'] {
      grid-column: 1 / -1;
    }

    form[data-testid='form'] > div:has(#phone_number) {
      display: grid !important;
      grid-template-columns: 92px minmax(0, 1fr);
      gap: 0 !important;
      min-width: 0;
    }

    .phone-country-selector,
    .phone-country-selector > div {
      width: 92px !important;
      min-width: 0 !important;
    }

    .phone-country-selector button {
      box-sizing: border-box !important;
      width: 92px !important;
      height: 52px !important;
      min-height: 52px !important;
      border: 1px solid #e7e3dc !important;
      border-right: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    input,
    textarea {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      border: 1px solid #e7e3dc !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: 14px !important;
      line-height: 1.2 !important;
    }

    input:focus,
    textarea:focus {
      border: 1px solid #151515 !important;
      box-shadow: none !important;
      outline: 0 !important;
    }

    input {
      height: 52px !important;
      min-height: 52px !important;
      padding: 20px 18px 6px !important;
    }

    textarea {
      height: 200px !important;
      min-height: 200px !important;
      padding: 34px 18px 18px !important;
      resize: vertical !important;
    }

    label {
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: 10.5px !important;
      font-weight: 700 !important;
      letter-spacing: 0.08em !important;
      line-height: 1 !important;
      top: 9px !important;
      transform: none !important;
      text-transform: uppercase !important;
    }

    button[data-testid='btn-form-submit'] {
      box-sizing: border-box !important;
      display: flex !important;
      width: 100% !important;
      height: 56px !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 56px !important;
      padding: 0 18px !important;
      border-radius: 0 !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: 11.5px !important;
      font-weight: 700 !important;
      letter-spacing: 0.08em !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
    }

    @media (max-width: 749px) {
      form[data-testid='form'] {
        grid-template-columns: 1fr;
      }

      form[data-testid='form'] > * {
        grid-column: 1 !important;
      }
    }
  `;

  const currencyCountries = {
    AED: 'AE',
    AUD: 'AU',
    CAD: 'CA',
    CHF: 'CH',
    GBP: 'GB',
    HKD: 'HK',
    INR: 'IN',
    JPY: 'JP',
    NZD: 'NZ',
    SGD: 'SG',
  };

  const applyCountry = (host, wrapper, attempt = 0) => {
    if (host.dataset.codebrwnCountryApplied === 'true') return;

    const country = wrapper.dataset.countryCode?.toUpperCase();
    const currency = wrapper.dataset.currencyCode?.toUpperCase();
    const desiredCountry = currencyCountries[currency] || country;
    const button = host.shadowRoot?.querySelector('button[aria-label^="Country code"]');

    if (!desiredCountry || !button) {
      if (attempt < 50) window.setTimeout(() => applyCountry(host, wrapper, attempt + 1), 100);
      return;
    }

    button.click();

    const selectOption = (optionAttempt = 0) => {
      const option = host.shadowRoot?.getElementById(`select-country-${desiredCountry}`);

      if (!option) {
        if (optionAttempt < 20) window.setTimeout(() => selectOption(optionAttempt + 1), 50);
        return;
      }

      option.click();
      host.dataset.codebrwnCountryApplied = 'true';
    };

    window.setTimeout(selectOption, 0);
  };

  const newsletterStyles = `
    :host {
      --app-embed-padding-x: 0px;
      --app-embed-padding-y: 0px;
      --inline-container-max-width: 100%;
      --container-max-w: 100%;
      --forms-body-font: normal 400 13px var(--font-body-family, Arial, sans-serif);
      --form-background-color: transparent;
      --form-text-color: #ffffff;
      --form-placeholder-color: rgba(255, 255, 255, 0.54);
      --form-field-border: 0 0 0 1px rgba(255, 255, 255, 0.26);
      --form-field-border-focused: 0 0 0 2px #ffffff;
      --form-field-border-radius: 0px;
      --button-border-radius: 0px;
      --button-padding: 14px;
    }

    [data-sizing='form-wrapper'],
    section[role='dialog'],
    form[data-testid='form'] {
      width: 100% !important;
      max-width: none !important;
    }

    [data-sizing='form-wrapper'] {
      height: auto !important;
      min-height: 0 !important;
    }

    div:has(> #form-container-ref) {
      justify-content: stretch !important;
      grid-template-columns: minmax(0, 1fr) !important;
    }

    #form-container-ref {
      width: 100% !important;
      max-width: none !important;
    }

    form[data-testid='form'] {
      box-sizing: border-box !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 0 !important;
      overflow: hidden !important;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.46) !important;
    }

    form[data-testid='form'] > div:first-child {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }

    input {
      box-sizing: border-box !important;
      width: 100% !important;
      height: 44px !important;
      min-height: 44px !important;
      padding: 0 14px !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      color: #ffffff !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: 13px !important;
    }

    label {
      color: rgba(255, 255, 255, 0.54) !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: 13px !important;
    }

    button[data-testid='btn-form-submit'] {
      box-sizing: border-box !important;
      display: flex !important;
      min-width: 56px !important;
      height: 44px !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 44px !important;
      padding: 0 15px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #ffffff !important;
      box-shadow: inset 1px 0 0 rgba(0, 0, 0, 0.18) !important;
      color: #000000 !important;
      font-family: var(--font-body-family, Arial, sans-serif) !important;
      font-size: 11.5px !important;
      font-weight: 700 !important;
      letter-spacing: 0.06em !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
    }

    button[data-testid='btn-form-submit']:hover,
    button[data-testid='btn-form-submit']:focus-visible {
      background: #eeeeee !important;
      color: #000000 !important;
    }
  `;

  const applyStyles = (host, attempt = 0) => {
    if (!host.shadowRoot) {
      if (attempt < 100) window.setTimeout(() => applyStyles(host, attempt + 1), 100);
      return;
    }

    if (host.shadowRoot.getElementById(styleId)) return;

    const wrapper = host.closest('.cb-shopify-form');
    if (!wrapper) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = wrapper.classList.contains('cb-shopify-form--contact') ? contactStyles : newsletterStyles;
    host.shadowRoot.append(style);

    if (wrapper.classList.contains('cb-shopify-form--contact')) applyCountry(host, wrapper);
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('.cb-shopify-form shopify-forms-embed').forEach((host) => applyStyles(host));
  };

  scan();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('.cb-shopify-form shopify-forms-embed')) applyStyles(node);
        scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
